import React, { useState, useEffect } from 'react';
import './CourseSelection.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Box, CircularProgress, Button } from '@mui/material';
import {
  setCourseDetails,
  fetchDynamicDataRequest,
  setSteps,
} from '../../../redux/actions/WizardLaunchActions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

function CourseSelection({ setFormState, handleNext }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigationPath = useSelector(
    (state) => state.wizardLaunch.navigationPath
  );
  const courseDetails = useSelector(
    (state) => state.wizardLaunch.courseDetails
  );
  const dynamicData = useSelector(
    (state) => state.wizardLaunch.screenData['course-selection']
  );
  const isLoading = useSelector(
    (state) => state.wizardLaunch.dynamicDataLoading
  );
  const error = useSelector((state) => state.wizardLaunch.dynamicDataError);
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (courseDetails?.hasCourse !== undefined) {
      setSelectedValue(courseDetails.hasCourse);
    }
  }, [courseDetails]);

  // Listen for saga-initiated navigation
  useEffect(() => {
    if (
      navigationPath &&
      navigationPath !== '/course-selection' &&
      navigationPath !== '/'
    ) {
      navigate(navigationPath);
    }
  }, [navigationPath, navigate]);

  const handleOptionClick = (option) => {
    const hasCourse = option.answer.id === 'yes';
    setSelectedValue(hasCourse);
    dispatch(setCourseDetails({ hasCourse }));

    // Update steps array based on user selection
    if (hasCourse) {
      dispatch(setSteps(['', '', '', '']));
    } else {
      dispatch(setSteps(['', '', '', '', '']));
    }
    // Prepare form data for API request
    const formData = {
      question_id: option.next_question_id,
    };

    // Update local form state first (for UI rendering)
    setFormState({
      question_id: option.next_question_id,
      userAnswer: {
        question_answer_id: option.question_answer_id,
        answer: option.answer,
        next_question_id: option.next_question_id,
      },
      question_type:
        option.next_question_type ||
        dynamicData?.question_type ||
        'course-selection',
    });

    // Trigger the saga to handle the API call and navigation
    dispatch(fetchDynamicDataRequest(formData));

    // Still call handleNext for any other state updates
    //handleNext();
  };

  // Handle back navigation to main page or previous step
  const handleBack = () => {
    navigate('/');
  };

  if (isLoading) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='200px'
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='200px'
      >
        <Typography color='error'>
          Error loading courses. Please try again later.
        </Typography>
      </Box>
    );
  }

  return (
    <Box className='box-grid-parent'>
      <Typography className='h5-title' variant='h5' gutterBottom>
        {dynamicData?.question_text || 'Loading...'}
      </Typography>

      <Box className='box-grid-wrap'>
        {dynamicData?.options?.map((option) => (
          <div
            className={`box-grid-col ${
              selectedValue === (option.answer.id === 'yes') ? 'selected' : ''
            }`}
            key={option.question_answer_id}
            onClick={() => handleOptionClick(option)}
          >
            <div className='check-icon-wrap'>
              {option.answer.id === 'yes' ? (
                <CheckCircleIcon />
              ) : (
                <CancelIcon />
              )}
            </div>
            {option.answer.name}
          </div>
        ))}
      </Box>
    </Box>
  );
}

export default CourseSelection;
